import React, { Component } from 'react';
import JobsDashboard from './Commons/JobsDashboard.js';

export default class TransferDashboard extends Component {
	render() {
		return (
			<div>
				<JobsDashboard operationName={'Transfer'} operationType={'INTRA_WAREHOUSE_TRANSFER'} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/TransferDashboard.js